import React from 'react';
import cx from 'classnames';

import s from './Version.module.sass';

type VersionProps = {
  version: string | null
  className?: string
};

enum VersionEnum {
  OLD = 'Old',
  NEW = 'New',
}

const Version: React.FC<VersionProps> = ({
  version,
  className,
}) => {
  const isOldVersion = version === VersionEnum.OLD;

  const compoundClassName = cx(
    s.root,
    { [s.old]: isOldVersion },
    { [s.new]: !isOldVersion },
    className,
  );

  if (!version) {
    return null;
  }

  return (
    <div className={compoundClassName}>
      {version}
    </div>
  );
};
export default Version;
